<ppl-box-container-with-title
  [title]="title"
  [description]="description"
  [small]="true">
  @if (error) {
    <ppl-error-box>
      @switch (error) {
        @case (LoginError.ERROR_INCORRECT_LOGIN) {
          <span i18n="@@Login_incorrect_login_error">There was an error with your E-Mail/Password combination.</span>
          <span>&nbsp;</span>
          <a
            href="https://support.pipelinersales.com"
            target="_blank"
            i18n="@@Do_you_need_help?"
            >Do you need help?</a
          >
        }
        @case (LoginError.ERROR_SESSION_EXPIRED) {
          <ng-container i18n="@@This_link_is_not_valid_anymore.">This link is not valid anymore.</ng-container>
        }
        @case (LoginError.ERROR_INVALID_MESSAGE) {
          <ng-container i18n="@@Invalid_request_data_sent.">Invalid request data sent.</ng-container>
        }
        @case (LoginError.ERROR_3RD_PARTY_AUTH_FAILED) {
          <ng-container i18n="@@Authentication_with_your_IDP_provider_failed.">Authentication with your IDP provider failed.</ng-container>
        }
        @case (LoginError.ERROR_UNKNOWN_USER) {
          <ng-container i18n="@@The_account_doesn't_exist._You_need_an_invitation_or_you_can_create_a_new_account">
            The account doesn't exist. You need an invitation or you can
            <a
              href="https://www.pipelinersales.com/crm/free-trial"
              target="_blank"
              tabindex="-1"
              >Create a new account</a
            >.
          </ng-container>
        }
        @case (LoginError.ERROR_UNEXPECTED_USER) {
          <ng-container i18n="@@LoginSuccessfullButUnexpectedUser">User {{ errorInfo.current_username }} can not login with active user {{ errorInfo.expected_username }}. Please try to login with different (not AD authenticated) browser.</ng-container>
        }
        @case (LoginError.ERROR_ACCOUNT_DISABLED) {
          <ng-container i18n="@@The_account_is_inactive.">The account is inactive.</ng-container>
        }
        @case (LoginError.ERROR_TOO_MANY_FAILED_LOGIN_ATTEMPTS) {
          <ng-container i18n="@@LoginFailedTooManyFailedAttempts">Your login is temporarily blocked as you reached the maximum number of unsuccessful attempts to log in. Try to login in a few minutes.</ng-container>
        }
        @default {
          @if (error_str) {
            <span i18n="@@Error">Error</span><span>: {{ error_str }}</span>
          } @else {
            <span i18n="@@Unknown_error.">Unknown error.</span>
          }
        }
      }
    </ppl-error-box>
  }
  <ng-content></ng-content>

  @if (loading) {
    <ppl-loading-overlay
      [large]="true"
      [visible]="true"
      [inverse]="true"></ppl-loading-overlay>
  }
</ppl-box-container-with-title>

<div class="copyright-login">
  <div class="copyright-login-row">
    <a
      href="https://www.pipelinersales.com/terms/"
      i18n="@@Terms_&_Conditions"
      class="link"
      target="_blank"
      >Terms & Conditions</a
    >

    <div class="separator"></div>

    <a
      href="https://www.pipelinersales.com/privacy/"
      i18n="@@Privacy_Policy"
      class="link"
      target="_blank"
      >Privacy Policy</a
    >
  </div>
  <span>&copy; {{ currentYear }} Pipelinersales Inc.</span>
</div>
